export default "__VITE_ASSET__xmXFJlQ2__"